
import { useAuth } from "./AuthContext";

// Custom hook to clear the state of BusinessContext
export const useClearState = () => {
  const { dispatch: authDispatch} = useAuth();
  
  // Function to clear the state
  const clearAllState = () => {
    authDispatch({ type: 'CLEAR'});
  }

  return clearAllState;
};
